window.onload = function () {
	let todayDate, endDate, t;
	const subjectNode = document.getElementById('js-eigen-timer-subject');
	const dateNode = document.getElementById('js-eigen-timer-date');
	const eventTitleNode = document.getElementById('js-personal-event-subject');
	const currentInfoNode = document.getElementById('js-current-info-text-eigen-timer');

	subjectNode.addEventListener('change', function () {
		eventTitleNode.innerHTML = 'Is het bijna ' + this.value + '?';

		updateUrl('subject', this.value);
	});

	dateNode.addEventListener('change', function () {
		clearTimeout(t);

		let countdownTarget = event.target.valueAsDate;
		let countdownTargetTimezoneCorrection = new Date(countdownTarget.getTime() + countdownTarget.getTimezoneOffset() * 60 * 1000);
		endDate = new Date(countdownTargetTimezoneCorrection);

		updateUrl('date', this.value);

		t = window.setInterval(outputUpdate, 1000);
	});

	var subjectParam = getParameterByName('subject');
	var dateParam = getParameterByName('date');

	if (subjectParam != null && dateParam != null) {
		subjectNode.value = subjectParam;
		dateNode.value = dateParam;

		subjectNode.dispatchEvent(new Event('change'));
		dateNode.dispatchEvent(new Event('change'));
	}

	function outputUpdate() {
		todayDate = new Date();
		const dur = endDate - todayDate;
		seconds = Math.floor((dur % (1000 * 60)) / 1000);
		minutes = Math.floor((dur % (1000 * 60 * 60)) / (1000 * 60));
		hours = Math.floor((dur % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		days = Math.floor(dur / (1000 * 60 * 60 * 24));

		let daysText = (days === 1) ? 'dag' : 'dagen';
		let minutesText = (minutes === 1) ? 'minuut' : 'minuten';
		let secondsText = (seconds === 1) ? 'seconde' : 'seconden';
		const hoursText = 'uur';

		if (dur >= 0) {
			document.getElementById('js-countdown--eigen-timer').style.display = 'block';
			currentInfoNode.innerHTML = 'Je afteller is aan het aftellen!! Je hebt nog...';
		} else {
			document.getElementById('js-countdown--eigen-timer').style.display = 'none';
			currentInfoNode.innerHTML = 'YES! Je datum is bereikt!';
		}

		// Display the result in the elements
		document.getElementById('js-number-days-eigen-timer').innerHTML = days;
		document.getElementById('js-number-hours-eigen-timer').innerHTML = hours;
		document.getElementById('js-number-minutes-eigen-timer').innerHTML = minutes;
		document.getElementById('js-number-seconds-eigen-timer').innerHTML = seconds;

		document.getElementById('js-text-days-eigen-timer').innerHTML = daysText;
		document.getElementById('js-text-hours-eigen-timer').innerHTML = hoursText;
		document.getElementById('js-text-minutes-eigen-timer').innerHTML = minutesText;
		document.getElementById('js-text-seconds-eigen-timer').innerHTML = secondsText;
	}
};

function getParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function updateUrl(param, value) {
	var currentUrl = new URL(window.location);
	currentUrl.searchParams.set(param, value);
	history.pushState({}, null, currentUrl.toString());
}
